import { Image, Text, Circle } from "@chakra-ui/react";
import { getActivityBgColor } from "@utils/theme/colors";
import deleteIcon from "./img/delete.svg";

const AlertDialogHeaderIcon = ({ variant, icon, activityType, activity }) => {
  let src = icon;

  switch (variant) {
    case "delete":
      src = deleteIcon;
  }

  // Check if icon is an emoji (Unicode character or short string)
  const isEmoji =
    icon && icon.length <= 4 && !icon.includes(".svg") && !icon.includes("/");

  if (isEmoji) {
    // Render emoji as text in a circle with activity-specific color
    return (
      <Circle
        size="24px"
        bg={getActivityBgColor(activityType, activity)}
        mr="8px"
      >
        <Text fontSize="14px" lineHeight="1">
          {icon}
        </Text>
      </Circle>
    );
  }

  // Render SVG image
  return <Image mr="14px" src={src} />;
};

export default AlertDialogHeaderIcon;
